import { useSelector } from 'react-redux';

/**
 * Get the roles and permissions from the currenty logged in user.
 *
 * @returns {Object} The roles and permissions object.
 */
export const usePermissionGroupsAndRoles = () => {
  const permissionGroups = useSelector((state) => state.user.permissionGroups) ?? [];
  const roles = useSelector((state) => state.user.roles) ?? [];

  return { permissionGroups, roles };
};

/**
 * Check if the given to or forRole matches the user permission groups/roles.
 *
 * @param {string|string[]|boolean} forGroup The required permission groups.
 * @param {string|string[]|boolean} forRole The required roles.
 *
 * @returns {boolean} True if allowed, false otherwise.
 */
export default (forGroup, forRole) => {
  const { permissionGroups, roles } = usePermissionGroupsAndRoles();

  // If not production and this is a developer, allow it.
  if (!__PRODUCTION__ && roles.includes('developer')) {
    return true;
  }

  if (forGroup !== false) {
    const value = Array.isArray(forGroup) ? forGroup : [forGroup];

    // Every permission should be matched.
    return value.every((perm) => permissionGroups.includes(perm));
  }

  const value = Array.isArray(forRole) ? forRole : [forRole];

  // At least one role should match.
  return value.some((role) => roles.includes(role));
};
